import { LogOut } from "lucide-react";
import { Link, Navigate, Outlet, useNavigate } from "react-router-dom";
import { getSessionToken, signOut } from "../api/client";
import { AttendWordmark, PortalFooter } from "./ui";

// Signed-in chrome: small Attend identity, polished dark frame, and dense
// client reporting content inside.
export function PortalLayout() {
  const navigate = useNavigate();

  if (!getSessionToken()) {
    return <Navigate to="/sign-in" replace />;
  }

  return (
    <div className="flex flex-col">
      {/* Header + content own the full viewport; the footer sits below the fold. */}
      <div className="flex min-h-dvh flex-col">
      <header className="sticky top-0 z-20 border-b border-hairline bg-paper/82 backdrop-blur-xl">
        <div className="mx-auto flex h-14 w-full max-w-5xl items-center justify-between px-5">
          <Link to="/" className="flex min-w-0 flex-col justify-center gap-1">
            <AttendWordmark className="h-3" />
            <span className="eyebrow">Client portal</span>
          </Link>
          <button
            type="button"
            className="btn-quiet"
            onClick={() => {
              signOut();
              navigate("/sign-in", { replace: true });
            }}
          >
            <LogOut size={14} />
            Sign out
          </button>
        </div>
      </header>

      <main className="mx-auto w-full max-w-5xl flex-1 px-5 pb-16 pt-8">
        <Outlet />
      </main>
      </div>

      <footer className="border-t border-hairline">
        <PortalFooter className="mx-auto w-full max-w-5xl px-5 py-5" />
      </footer>
    </div>
  );
}
